import Rest from '@/services/Rest';

/**
 * @typedef {RefundService}
 */
export default class RefundService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/refund-solicitation'
}
